import { TFunction } from 'i18next';

// Format uptime from seconds to readable format
export const formatUptime = (seconds?: number) => {
  if (!seconds) return 'N/A';
  
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  
  let result = '';
  if (days > 0) result += `${days}d `;
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m `;
  result += `${remainingSeconds}s`;
  
  return result;
};
// Get battery status based on percentage
export const getBatteryStatus = (t: TFunction, percentage?: number) => {
  if (!percentage) return 'N/A';
  if (percentage > 80) return t('heartbeat.battery.excellent');
  if (percentage > 50) return t('heartbeat.battery.good');
  if (percentage > 20) return t('heartbeat.battery.low');
  return t('heartbeat.battery.critical');
};

// Calculate battery status color
export const getBatteryStatusColor = (percentage?: number) => {
  if (!percentage) return '#e5e7eb';
  if (percentage > 60) return '#22c55e';
  if (percentage > 20) return '#facc15';
  return '#ef4444';
};

// Format timestamp
export const formatTimestamp = (timestamp?: string) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleString();
};

// Convert bytes to more readable format
export const formatBytes = (bytes?: number) => {
  if (!bytes) return 'N/A';
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 B';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / (1024 ** i)).toFixed(2)} ${sizes[i]}`;
};